export interface MaintenanceSystem {
  id: string
  header: string
  text: string
  footer: string
  dateStart: string
  dateEnd: string
  dateStartNotic: string
  dateEndNotic: string
  imagePath: string
  status: string
  createAt: string
  updateAt: string
  textDate: string
  splitStartTime: string
  splitEndTime: string
}
export const MaintenanceSystem_INIT: MaintenanceSystem = {
  id: '',
  header: '',
  text: '',
  footer: '',
  dateStart: '',
  dateEnd: '',
  dateStartNotic: '',
  dateEndNotic: '',
  imagePath: '',
  status: '',
  createAt: '',
  updateAt: '',
  textDate: '',
  splitStartTime: '',
  splitEndTime: '',
}
